var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269 70",
    width: 269,
    height: 70,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#F7FDFD",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 70.00  L 269.00 70.00 L 269.00 0.00 L 0.00 0.00 L 0.00 70.00 M 33.00 15.00  C 32.70 16.07 31.88 16.56 31.00 17.00 C 30.16 17.42 28.93 17.46 28.00 18.00 C 28.04 17.97 25.90 20.27 26.00 20.00 C 25.87 20.57 25.80 22.45 26.00 23.00 C 25.92 22.77 28.19 25.12 28.00 25.00 C 28.01 25.01 30.15 26.04 30.00 26.00 C 30.47 26.13 31.87 26.22 32.00 26.00 C 31.96 26.07 33.85 26.97 34.00 27.00 C 34.48 27.09 35.82 26.76 36.00 27.00 C 35.38 26.17 38.75 28.20 38.00 28.00 C 38.50 28.00 39.96 28.14 40.00 28.00 C 40.36 26.82 42.05 29.03 42.00 29.00 C 43.42 29.56 45.80 30.27 47.00 31.00 C 49.01 32.22 50.22 33.83 51.00 36.00 C 51.16 36.44 51.00 37.00 51.00 37.00 C 56.80 44.84 45.46 54.30 38.00 54.00 C 37.50 53.98 36.50 54.04 36.00 54.00 C 29.29 53.49 32.38 44.81 38.00 45.00 C 38.50 45.02 39.00 45.00 39.00 45.00 C 39.07 44.93 41.06 42.83 41.00 43.00 C 41.16 42.33 41.16 40.67 41.00 40.00 C 41.06 40.17 38.91 37.93 39.00 38.00 C 37.88 37.35 37.25 37.28 36.00 37.00 C 34.33 36.63 34.22 37.13 33.00 36.00 C 32.51 36.06 32.00 36.00 32.00 36.00 C 30.37 36.20 30.01 35.94 29.00 35.00 C 28.51 35.06 28.00 35.00 28.00 35.00 C 26.22 35.21 26.15 34.56 25.00 34.00 C 23.64 33.33 22.33 32.71 21.00 32.00 C 20.37 31.67 19.57 31.36 19.00 31.00 C 17.96 30.35 17.59 30.06 17.00 29.00 C 13.62 22.87 16.10 17.50 19.75 12.75 C 23.41 8.01 35.22 7.12 33.00 15.00 M 43.00 12.00  C 43.77 13.68 44.11 13.32 43.00 15.00 C 42.10 18.42 34.12 17.61 35.03 12.97 C 35.93 8.34 41.02 7.68 43.00 12.00 M 49.00 20.00  C 49.21 20.42 47.51 22.25 47.00 22.00 C 35.97 22.31 51.29 9.73 49.00 20.00 M 234.00 19.00  C 234.09 19.48 234.09 20.52 234.00 21.00 C 233.83 21.90 232.83 22.80 232.00 23.00 C 230.07 23.74 228.85 22.30 228.00 21.00 C 227.08 19.59 227.13 20.33 228.00 19.00 C 228.31 17.28 230.52 16.64 232.00 17.00 C 232.87 17.21 233.84 18.13 234.00 19.00 M 84.00 19.00  C 85.18 20.34 85.11 22.05 85.00 24.00 C 83.46 24.37 82.60 22.57 81.00 23.00 C 79.81 22.90 78.18 22.80 77.00 23.00 C 75.52 23.62 73.62 23.57 74.00 26.00 C 73.96 25.77 77.03 29.02 77.00 29.00 C 80.05 30.76 82.76 30.75 85.00 34.00 C 85.60 34.87 85.81 34.68 86.00 36.00 C 86.57 37.94 85.90 40.36 85.00 42.00 C 84.41 43.07 84.03 43.44 83.00 44.00 C 81.24 44.96 80.01 44.87 78.00 45.00 C 75.57 45.42 74.57 46.22 72.00 45.00 C 71.50 45.00 70.47 45.12 70.00 45.00 C 65.71 43.89 68.67 40.19 70.00 40.00 C 71.94 39.73 82.47 43.45 80.00 37.00 C 79.44 37.56 78.08 35.07 78.00 35.00 C 75.80 33.60 73.15 33.17 71.00 32.00 C 70.16 31.54 69.16 31.06 69.00 30.00 C 68.93 29.51 69.00 29.00 69.00 29.00 C 68.42 28.13 68.16 28.32 68.00 27.00 C 67.96 26.66 67.78 24.20 68.00 24.00 C 68.22 21.91 70.05 19.85 72.00 19.00 C 74.53 17.90 79.13 17.57 82.00 18.00 C 83.43 18.21 83.11 18.00 84.00 19.00 M 200.00 19.00  C 201.38 20.57 200.99 22.79 201.00 25.00 C 198.08 21.90 193.53 22.93 190.00 24.00 C 189.82 24.12 188.11 25.86 188.00 26.00 C 187.36 27.11 187.20 27.72 187.00 29.00 C 186.75 30.61 186.65 33.41 187.00 35.00 C 188.13 37.82 189.42 38.66 192.00 40.00 C 192.49 40.08 193.54 39.87 194.00 40.00 C 193.88 39.97 196.52 41.02 196.00 41.00 C 197.71 40.43 199.32 39.69 201.00 39.00 C 201.52 41.83 200.88 45.95 197.00 45.00 C 194.42 45.91 193.43 45.50 191.00 45.00 C 189.36 44.85 187.50 44.68 186.00 44.00 C 183.36 42.79 181.26 39.75 181.00 37.00 C 180.95 36.50 181.00 36.00 181.00 36.00 C 179.10 33.44 180.33 30.46 181.00 28.00 C 182.79 21.39 190.14 16.82 198.00 18.00 C 199.43 18.21 199.12 17.99 200.00 19.00 M 45.00 27.00  C 44.45 18.93 53.11 27.49 45.00 27.00 M 125.00 26.00  C 126.63 26.01 127.61 26.23 129.00 27.00 C 129.84 27.47 130.84 27.93 131.00 29.00 C 131.07 29.49 131.00 30.00 131.00 30.00 C 131.95 31.02 131.89 31.45 132.00 33.00 C 132.09 34.28 132.09 35.72 132.00 37.00 C 131.88 38.70 132.06 38.86 131.00 40.00 C 131.06 40.49 131.00 41.00 131.00 41.00 C 130.28 42.48 128.56 44.46 127.00 45.00 C 126.55 45.15 125.50 45.00 125.00 45.00 C 123.00 45.81 122.62 45.08 121.00 45.00 C 120.03 44.94 119.21 43.43 118.00 44.00 C 118.00 47.33 118.00 50.67 118.00 54.00 C 116.33 54.00 114.67 54.00 113.00 54.00 C 110.57 52.47 112.01 42.86 112.00 40.00 C 111.99 37.14 110.59 27.52 113.00 26.00 C 116.30 23.91 118.05 28.61 119.00 28.00 C 119.87 27.44 119.67 26.24 121.00 26.00 C 121.48 25.91 122.50 26.00 123.00 26.00 C 124.55 25.60 123.54 25.63 125.00 26.00 M 146.00 26.00  C 149.45 26.34 150.76 28.22 152.00 31.00 C 152.47 32.05 153.09 32.39 153.00 34.00 C 153.08 34.99 152.94 36.01 153.00 37.00 C 149.00 37.00 145.00 37.00 141.00 37.00 C 140.81 37.08 140.91 38.52 141.00 39.00 C 141.94 40.50 142.23 40.72 144.00 41.00 C 145.26 41.20 146.72 41.00 148.00 41.00 C 148.50 41.00 149.55 41.15 150.00 41.00 C 153.10 39.93 152.60 44.25 150.00 45.00 C 149.19 45.23 147.85 45.00 147.00 45.00 C 144.77 45.48 144.26 45.68 142.00 45.00 C 139.58 44.68 138.52 43.67 137.00 42.00 C 135.46 40.31 135.29 40.55 135.00 38.00 C 134.83 36.50 134.80 34.50 135.00 33.00 C 135.34 30.48 136.68 28.23 139.00 27.00 C 140.46 26.23 141.31 26.09 143.00 26.00 C 144.75 25.59 144.25 25.45 146.00 26.00 M 216.00 26.00  C 217.66 26.09 218.55 26.25 220.00 27.00 C 221.35 27.70 222.34 28.68 223.00 30.00 C 224.15 32.31 224.40 35.34 224.00 38.00 C 223.77 39.56 223.71 38.93 223.00 40.00 C 223.03 40.50 223.00 41.00 223.00 41.00 C 222.54 42.37 221.17 43.39 220.00 44.00 C 218.52 44.77 217.69 44.85 216.00 45.00 C 213.74 45.51 213.29 45.76 211.00 45.00 C 209.84 44.83 209.04 44.58 208.00 44.00 C 206.77 43.32 205.46 42.36 205.00 41.00 C 204.85 40.55 205.00 40.00 205.00 40.00 C 204.42 39.13 204.19 39.31 204.00 38.00 C 203.79 36.56 203.79 34.44 204.00 33.00 C 204.23 31.43 204.29 32.07 205.00 31.00 C 204.97 30.50 205.00 30.00 205.00 30.00 C 205.45 28.66 206.82 27.56 208.00 27.00 C 209.43 26.32 211.35 26.09 213.00 26.00 C 214.68 25.62 214.37 25.62 216.00 26.00 M 251.00 26.00  C 254.35 26.00 254.91 27.32 256.00 30.00 C 256.94 32.31 258.77 43.25 256.00 45.00 C 254.81 45.75 252.31 44.43 251.00 45.00 C 251.00 41.00 251.00 37.00 251.00 33.00 C 251.00 33.01 249.08 30.04 249.00 30.00 C 242.19 27.98 244.14 41.73 244.00 45.00 C 242.33 45.00 240.67 45.00 239.00 45.00 C 236.94 43.70 237.02 27.26 239.00 26.00 C 242.30 23.91 244.05 28.61 245.00 28.00 C 245.87 27.44 245.67 26.24 247.00 26.00 C 247.48 25.91 248.50 26.00 249.00 26.00 C 250.56 25.60 249.51 25.59 251.00 26.00 M 97.00 41.00  C 97.64 41.17 99.36 41.15 100.00 41.00 C 99.93 41.02 101.96 39.05 102.00 39.00 C 102.07 38.51 102.00 38.00 102.00 38.00 C 102.00 35.63 100.77 27.06 103.00 26.00 C 103.49 25.77 106.51 25.77 107.00 26.00 C 108.99 26.95 108.92 44.09 107.00 45.00 C 106.50 45.24 103.50 45.23 103.00 45.00 C 101.86 44.47 102.66 43.44 102.00 43.00 C 101.88 42.96 98.39 44.86 98.00 45.00 C 96.34 45.58 95.71 46.67 94.00 45.00 C 93.50 45.00 93.00 45.00 93.00 45.00 C 91.20 44.49 90.14 42.67 90.00 41.00 C 89.96 40.50 90.00 40.00 90.00 40.00 C 88.71 38.26 87.60 27.24 90.00 26.00 C 90.57 25.71 94.43 25.71 95.00 26.00 C 98.84 27.98 93.09 38.88 97.00 41.00 M 162.00 28.00  C 163.19 27.93 163.81 26.25 165.00 26.00 C 165.53 25.89 167.52 25.78 168.00 26.00 C 169.78 26.79 169.20 30.07 168.00 31.00 C 167.95 31.15 167.00 31.00 167.00 31.00 C 166.50 31.00 165.50 31.00 165.00 31.00 C 164.50 31.00 164.00 31.00 164.00 31.00 C 163.57 31.52 162.12 33.64 162.00 34.00 C 161.24 37.50 162.57 41.46 162.00 45.00 C 160.33 45.00 158.67 45.00 157.00 45.00 C 154.98 43.72 155.00 27.17 157.00 26.00 C 159.48 24.55 161.98 28.00 162.00 28.00 M 233.00 45.00  C 231.81 45.75 229.31 44.43 228.00 45.00 C 228.00 38.67 228.00 32.33 228.00 26.00 C 229.67 26.00 231.33 26.00 233.00 26.00 C 235.06 27.30 234.98 43.74 233.00 45.00 M 18.00 36.00  C 18.16 35.77 19.84 35.77 20.00 36.00 C 24.54 40.42 13.43 40.45 18.00 36.00 M 22.00 44.00  C 21.97 44.50 22.00 45.00 22.00 45.00 C 24.12 46.69 27.58 44.02 29.69 46.31 C 31.81 48.59 31.34 53.29 28.00 54.00 C 27.29 54.15 25.71 54.15 25.00 54.00 C 21.95 53.35 21.54 49.82 23.00 48.00 C 23.04 47.50 23.00 47.00 23.00 47.00 C 20.84 47.34 20.72 47.90 19.00 47.00 C 17.94 46.44 17.53 46.03 17.00 45.00 C 16.24 43.51 16.59 41.68 19.00 41.00 C 19.16 40.77 20.84 40.77 21.00 41.00 C 23.05 41.26 22.97 43.01 22.00 44.00 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 29.00  C 17.24 29.32 18.72 30.77 19.00 31.00 C 19.57 31.36 20.37 31.67 21.00 32.00 C 19.18 30.53 18.09 27.93 17.00 26.00 C 19.86 24.54 22.71 23.09 26.00 23.00 C 25.80 22.45 25.87 20.57 26.00 20.00 C 26.26 18.90 27.17 18.48 28.00 18.00 C 28.93 17.46 30.16 17.42 31.00 17.00 C 30.93 17.05 33.10 14.76 33.00 15.00 C 35.22 7.12 23.41 8.01 19.75 12.75 C 16.10 17.50 13.62 22.87 17.00 29.00 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 43.00 15.00  C 43.20 14.25 43.08 12.78 43.00 12.00 C 41.02 7.68 35.93 8.34 35.03 12.97 C 34.12 17.61 42.10 18.42 43.00 15.00 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 43.00 15.00  C 44.11 13.32 43.77 13.68 43.00 12.00 C 43.08 12.78 43.20 14.25 43.00 15.00 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 31.00 17.00  C 31.88 16.56 32.70 16.07 33.00 15.00 C 33.10 14.76 30.93 17.05 31.00 17.00 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 22.00  C 46.80 21.90 47.00 21.00 47.00 21.00 C 42.78 20.29 43.59 15.90 48.00 17.00 C 48.00 18.00 48.00 19.00 48.00 20.00 C 48.41 19.81 49.00 20.00 49.00 20.00 C 51.29 9.73 35.97 22.31 47.00 22.00 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 21.00  C 47.12 20.74 47.74 20.12 48.00 20.00 C 48.00 19.00 48.00 18.00 48.00 17.00 C 43.59 15.90 42.78 20.29 47.00 21.00 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 228.00 19.00  C 227.91 19.48 227.91 20.52 228.00 21.00 C 228.85 22.30 230.07 23.74 232.00 23.00 C 231.72 23.11 234.14 20.63 234.00 21.00 C 234.09 20.52 234.09 19.48 234.00 19.00 C 234.11 19.28 231.64 16.86 232.00 17.00 C 230.52 16.64 228.31 17.28 228.00 19.00 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 234.00 19.00  C 233.84 18.13 232.87 17.21 232.00 17.00 C 231.64 16.86 234.11 19.28 234.00 19.00 Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 26.00 20.00  C 25.90 20.27 28.04 17.97 28.00 18.00 C 27.17 18.48 26.26 18.90 26.00 20.00 Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 72.00 19.00  C 70.48 19.87 69.47 22.56 69.00 24.00 C 69.26 24.24 69.00 26.61 69.00 27.00 C 69.00 27.50 69.00 28.50 69.00 29.00 C 69.00 29.00 68.93 29.51 69.00 30.00 C 69.38 30.39 70.66 31.76 71.00 32.00 C 73.15 33.17 75.80 33.60 78.00 35.00 C 78.23 35.15 80.58 36.42 80.00 37.00 C 82.47 43.45 71.94 39.73 70.00 40.00 C 68.75 40.82 68.55 44.05 70.00 45.00 C 70.47 45.12 71.50 45.00 72.00 45.00 C 73.99 45.00 76.02 45.13 78.00 45.00 C 80.01 44.87 81.24 44.96 83.00 44.00 C 83.21 43.84 84.88 42.16 85.00 42.00 C 85.90 40.36 86.57 37.94 86.00 36.00 C 85.98 35.95 85.13 34.28 85.00 34.00 C 82.76 30.75 80.05 30.76 77.00 29.00 C 76.03 28.44 74.07 27.29 74.00 26.00 C 73.62 23.57 75.52 23.62 77.00 23.00 C 79.08 22.14 79.23 22.79 81.00 23.00 C 82.60 22.57 83.46 24.37 85.00 24.00 C 85.11 22.05 85.18 20.34 84.00 19.00 C 84.56 19.45 81.38 17.82 82.00 18.00 C 79.13 17.57 74.53 17.90 72.00 19.00 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 84.00 19.00  C 83.11 18.00 83.43 18.21 82.00 18.00 C 81.38 17.82 84.56 19.45 84.00 19.00 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 181.00 28.00  C 180.69 30.58 181.00 33.40 181.00 36.00 C 181.00 36.00 180.95 36.50 181.00 37.00 C 182.37 38.70 183.96 42.81 186.00 44.00 C 187.50 44.68 189.36 44.85 191.00 45.00 C 192.79 45.16 195.24 45.31 197.00 45.00 C 200.88 45.95 201.52 41.83 201.00 39.00 C 199.32 39.69 197.71 40.43 196.00 41.00 C 195.55 41.15 194.46 41.14 194.00 41.00 C 192.82 40.64 192.88 40.46 192.00 40.00 C 189.42 38.66 188.13 37.82 187.00 35.00 C 185.99 32.47 186.16 31.46 187.00 29.00 C 187.20 27.72 187.36 27.11 188.00 26.00 C 188.60 24.96 188.94 24.53 190.00 24.00 C 193.53 22.93 198.08 21.90 201.00 25.00 C 200.99 22.79 201.38 20.57 200.00 19.00 C 200.55 19.44 197.39 17.83 198.00 18.00 C 190.14 16.82 182.79 21.39 181.00 28.00 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 200.00 19.00  C 199.12 17.99 199.43 18.21 198.00 18.00 C 197.39 17.83 200.55 19.44 200.00 19.00 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 24.00  C 68.27 23.75 69.00 24.00 69.00 24.00 C 69.47 22.56 70.48 19.87 72.00 19.00 C 70.05 19.85 68.22 21.91 68.00 24.00 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 228.00 21.00  C 227.91 20.52 227.91 19.48 228.00 19.00 C 227.13 20.33 227.08 19.59 228.00 21.00 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 21.00  C 47.00 21.00 46.80 21.90 47.00 22.00 C 47.51 22.25 49.21 20.42 49.00 20.00 C 49.00 20.00 48.41 19.81 48.00 20.00 C 47.74 20.12 47.12 20.74 47.00 21.00 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 232.00 23.00  C 232.83 22.80 233.83 21.90 234.00 21.00 C 234.14 20.63 231.72 23.11 232.00 23.00 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 77.00 23.00  C 78.18 22.80 79.81 22.90 81.00 23.00 C 79.23 22.79 79.08 22.14 77.00 23.00 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 21.00 32.00  C 22.33 32.71 23.64 33.33 25.00 34.00 C 26.61 34.48 26.77 33.86 28.00 35.00 C 28.00 35.00 28.51 35.06 29.00 35.00 C 30.63 34.80 30.99 35.06 32.00 36.00 C 32.00 36.00 32.51 36.06 33.00 36.00 C 34.78 35.79 34.88 36.56 36.00 37.00 C 37.25 37.28 37.88 37.35 39.00 38.00 C 39.89 38.52 40.74 38.90 41.00 40.00 C 41.16 40.67 41.16 42.33 41.00 43.00 C 40.80 43.85 39.87 44.87 39.00 45.00 C 39.00 45.00 38.50 45.02 38.00 45.00 C 34.95 46.48 29.56 52.16 36.00 54.00 C 36.50 54.04 37.50 53.98 38.00 54.00 C 46.11 51.17 51.94 46.95 51.00 37.00 C 51.00 37.00 51.16 36.44 51.00 36.00 C 49.59 34.65 48.50 32.14 47.00 31.00 C 45.80 30.27 43.42 29.56 42.00 29.00 C 41.80 28.92 40.00 28.00 40.00 28.00 C 39.96 28.14 38.50 28.00 38.00 28.00 C 37.50 28.00 36.38 28.21 36.00 28.00 C 35.32 27.62 34.66 27.43 34.00 27.00 C 33.85 26.97 31.96 26.07 32.00 26.00 C 31.05 25.87 31.45 26.89 30.00 26.00 C 30.15 26.04 28.01 25.01 28.00 25.00 C 27.23 24.65 26.41 23.17 26.00 23.00 C 22.71 23.09 19.86 24.54 17.00 26.00 C 18.09 27.93 19.18 30.53 21.00 32.00 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 28.00 25.00  C 28.19 25.12 25.92 22.77 26.00 23.00 C 26.41 23.17 27.23 24.65 28.00 25.00 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 45.00 27.00  C 53.11 27.49 44.45 18.93 45.00 27.00 M 48.00 24.00  C 48.73 24.73 47.29 26.67 46.29 25.63 C 45.30 24.60 47.45 23.45 48.00 24.00 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 48.00 24.00  C 47.45 23.45 45.30 24.60 46.29 25.63 C 47.29 26.67 48.73 24.73 48.00 24.00 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 27.00  C 68.27 27.25 69.00 27.00 69.00 27.00 C 69.00 26.61 69.26 24.24 69.00 24.00 C 69.00 24.00 68.27 23.75 68.00 24.00 C 67.78 24.20 67.96 26.66 68.00 27.00 Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 188.00 26.00  C 188.11 25.86 189.82 24.12 190.00 24.00 C 188.94 24.53 188.60 24.96 188.00 26.00 Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 123.00 26.00  C 123.50 26.00 124.50 26.00 125.00 26.00 C 123.54 25.63 124.55 25.60 123.00 26.00 Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 143.00 26.00  C 143.95 25.95 145.05 25.91 146.00 26.00 C 144.25 25.45 144.75 25.59 143.00 26.00 Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 213.00 26.00  C 213.97 25.95 215.03 25.95 216.00 26.00 C 214.37 25.62 214.68 25.62 213.00 26.00 Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 249.00 26.00  C 249.50 26.00 250.50 26.00 251.00 26.00 C 249.51 25.59 250.56 25.60 249.00 26.00 Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 32.00 26.00  C 31.87 26.22 30.47 26.13 30.00 26.00 C 31.45 26.89 31.05 25.87 32.00 26.00 Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 77.00 29.00  C 77.03 29.02 73.96 25.77 74.00 26.00 C 74.07 27.29 76.03 28.44 77.00 29.00 Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 40.00  C 90.00 35.33 90.00 30.67 90.00 26.00 C 87.60 27.24 88.71 38.26 90.00 40.00 Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 40.00  C 90.00 40.00 89.96 40.50 90.00 41.00 C 90.85 42.14 92.00 43.85 93.00 45.00 C 93.00 45.00 93.50 45.00 94.00 45.00 C 95.28 45.00 96.73 45.19 98.00 45.00 C 98.39 44.86 101.88 42.96 102.00 43.00 C 102.70 42.30 103.08 45.06 103.00 45.00 C 103.50 45.23 106.50 45.24 107.00 45.00 C 107.00 38.67 107.00 32.33 107.00 26.00 C 106.51 25.77 103.49 25.77 103.00 26.00 C 102.40 29.85 104.25 34.96 102.00 38.00 C 102.00 38.00 102.07 38.51 102.00 39.00 C 101.86 39.89 100.81 40.81 100.00 41.00 C 99.36 41.15 97.64 41.17 97.00 41.00 C 92.28 39.76 96.40 29.25 95.00 26.00 C 94.43 25.71 90.57 25.71 90.00 26.00 C 90.00 30.67 90.00 35.33 90.00 40.00 Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 97.00 41.00  C 93.09 38.88 98.84 27.98 95.00 26.00 C 96.40 29.25 92.28 39.76 97.00 41.00 Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 102.00 38.00  C 104.25 34.96 102.40 29.85 103.00 26.00 C 100.77 27.06 102.00 35.63 102.00 38.00 Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 107.00 45.00  C 108.92 44.09 108.99 26.95 107.00 26.00 C 107.00 32.33 107.00 38.67 107.00 45.00 Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 54.00  C 113.00 44.67 113.00 35.33 113.00 26.00 C 110.59 27.52 111.99 37.14 112.00 40.00 C 112.01 42.86 110.57 52.47 113.00 54.00 Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 54.00  C 114.67 54.00 116.33 54.00 118.00 54.00 C 118.00 50.67 118.00 47.33 118.00 44.00 C 119.21 43.43 120.03 44.94 121.00 45.00 C 122.32 45.08 123.68 45.00 125.00 45.00 C 125.50 45.00 126.55 45.15 127.00 45.00 C 128.41 43.91 129.45 42.08 131.00 41.00 C 131.00 41.00 131.06 40.49 131.00 40.00 C 130.80 38.36 131.82 37.92 132.00 37.00 C 132.09 35.72 132.09 34.28 132.00 33.00 C 131.83 32.17 130.82 31.48 131.00 30.00 C 131.00 30.00 131.07 29.49 131.00 29.00 C 130.62 28.60 129.34 27.25 129.00 27.00 C 127.61 26.23 126.63 26.01 125.00 26.00 C 124.50 26.00 123.50 26.00 123.00 26.00 C 122.50 26.00 121.48 25.91 121.00 26.00 C 120.37 26.24 119.94 27.64 119.00 28.00 C 118.05 28.61 116.30 23.91 113.00 26.00 C 113.00 35.33 113.00 44.67 113.00 54.00 M 126.00 32.00  C 126.07 32.49 126.00 33.00 126.00 33.00 C 127.65 34.69 126.64 35.41 126.00 37.00 C 126.00 37.50 126.09 38.52 126.00 39.00 C 125.83 39.92 124.83 40.77 124.00 41.00 C 123.17 41.23 120.82 41.24 120.00 41.00 C 118.38 40.52 118.26 39.41 118.00 38.00 C 117.30 34.24 119.12 28.60 124.00 30.00 C 124.45 29.55 125.95 31.68 126.00 32.00 Z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 119.00 28.00  C 119.94 27.64 120.37 26.24 121.00 26.00 C 119.67 26.24 119.87 27.44 119.00 28.00 Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 139.00 27.00  C 138.00 27.68 135.19 32.15 135.00 33.00 C 134.80 34.50 134.83 36.50 135.00 38.00 C 135.13 38.65 136.43 41.16 137.00 42.00 C 138.52 43.67 139.58 44.68 142.00 45.00 C 143.60 45.21 145.38 45.00 147.00 45.00 C 147.85 45.00 149.19 45.23 150.00 45.00 C 151.34 44.40 151.31 41.54 150.00 41.00 C 149.55 41.15 148.50 41.00 148.00 41.00 C 145.91 41.84 146.02 41.74 144.00 41.00 C 142.23 40.72 141.94 40.50 141.00 39.00 C 140.44 38.11 139.48 37.83 141.00 37.00 C 145.00 37.00 149.00 37.00 153.00 37.00 C 152.94 36.01 153.08 34.99 153.00 34.00 C 153.00 33.94 152.13 31.51 152.00 31.00 C 150.76 28.22 149.45 26.34 146.00 26.00 C 145.05 25.91 143.95 25.95 143.00 26.00 C 141.31 26.09 140.46 26.23 139.00 27.00 M 141.00 34.00  C 139.82 34.19 139.84 31.81 141.00 32.00 C 141.44 30.01 144.33 29.49 146.00 30.00 C 147.82 30.55 148.19 32.30 148.00 34.00 C 145.67 34.00 143.33 34.00 141.00 34.00 Z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 157.00 45.00  C 157.00 38.67 157.00 32.33 157.00 26.00 C 155.00 27.17 154.98 43.72 157.00 45.00 Z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 157.00 45.00  C 158.67 45.00 160.33 45.00 162.00 45.00 C 162.57 41.46 161.24 37.50 162.00 34.00 C 162.26 32.82 162.38 31.22 164.00 31.00 C 164.00 31.00 164.50 31.00 165.00 31.00 C 166.11 29.95 165.94 30.00 167.00 31.00 C 167.00 31.00 167.95 31.15 168.00 31.00 C 168.15 30.56 168.28 26.22 168.00 26.00 C 167.52 25.78 165.53 25.89 165.00 26.00 C 162.95 26.87 164.16 28.49 162.00 28.00 C 161.98 28.00 159.48 24.55 157.00 26.00 C 157.00 32.33 157.00 38.67 157.00 45.00 Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 162.00 28.00  C 164.16 28.49 162.95 26.87 165.00 26.00 C 163.81 26.25 163.19 27.93 162.00 28.00 Z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 168.00 31.00  C 169.20 30.07 169.78 26.79 168.00 26.00 C 168.28 26.22 168.15 30.56 168.00 31.00 Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 208.00 27.00  C 207.12 27.52 205.93 29.31 205.00 30.00 C 205.00 30.00 204.97 30.50 205.00 31.00 C 205.10 32.59 204.29 32.06 204.00 33.00 C 203.79 34.44 203.79 36.56 204.00 38.00 C 204.21 38.69 205.08 38.74 205.00 40.00 C 205.00 40.00 204.85 40.55 205.00 41.00 C 206.07 41.79 207.10 43.36 208.00 44.00 C 209.04 44.58 209.84 44.83 211.00 45.00 C 212.51 45.22 214.48 45.14 216.00 45.00 C 217.69 44.85 218.52 44.77 220.00 44.00 C 220.93 43.39 222.01 41.73 223.00 41.00 C 223.00 41.00 223.03 40.50 223.00 40.00 C 222.90 38.44 223.74 38.92 224.00 38.00 C 224.40 35.34 224.15 32.31 223.00 30.00 C 222.81 29.69 220.25 27.16 220.00 27.00 C 218.55 26.25 217.66 26.09 216.00 26.00 C 215.03 25.95 213.97 25.95 213.00 26.00 C 211.35 26.09 209.43 26.32 208.00 27.00 M 218.00 38.00  C 217.95 38.49 218.00 39.00 218.00 39.00 C 217.86 39.92 216.81 40.78 216.00 41.00 C 215.16 41.23 212.84 41.23 212.00 41.00 C 211.15 40.76 210.14 39.89 210.00 39.00 C 209.93 38.51 210.00 38.00 210.00 38.00 C 208.62 36.43 208.64 34.54 210.00 33.00 C 210.00 32.50 210.00 32.00 210.00 32.00 C 210.14 31.08 211.19 30.22 212.00 30.00 C 212.89 29.76 215.10 29.79 216.00 30.00 C 219.62 30.86 219.62 35.92 218.00 38.00 Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 233.00 45.00  C 233.00 38.67 233.00 32.33 233.00 26.00 C 231.33 26.00 229.67 26.00 228.00 26.00 C 228.00 32.33 228.00 38.67 228.00 45.00 C 229.31 44.43 231.81 45.75 233.00 45.00 Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 233.00 45.00  C 234.98 43.74 235.06 27.30 233.00 26.00 C 233.00 32.33 233.00 38.67 233.00 45.00 Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 239.00 45.00  C 239.00 38.67 239.00 32.33 239.00 26.00 C 237.02 27.26 236.94 43.70 239.00 45.00 Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 239.00 45.00  C 240.67 45.00 242.33 45.00 244.00 45.00 C 244.14 41.73 242.19 27.98 249.00 30.00 C 250.65 30.49 250.69 31.60 251.00 33.00 C 251.00 37.00 251.00 41.00 251.00 45.00 C 252.31 44.43 254.81 45.75 256.00 45.00 C 255.11 40.22 257.18 34.70 256.00 30.00 C 254.91 27.32 254.35 26.00 251.00 26.00 C 250.50 26.00 249.50 26.00 249.00 26.00 C 248.50 26.00 247.48 25.91 247.00 26.00 C 246.37 26.24 245.94 27.64 245.00 28.00 C 244.05 28.61 242.30 23.91 239.00 26.00 C 239.00 32.33 239.00 38.67 239.00 45.00 Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 28.00  C 245.94 27.64 246.37 26.24 247.00 26.00 C 245.67 26.24 245.87 27.44 245.00 28.00 Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 28.00  C 35.77 27.66 36.00 27.00 36.00 27.00 C 35.82 26.76 34.48 27.09 34.00 27.00 C 34.66 27.43 35.32 27.62 36.00 28.00 Z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 28.00  C 36.38 28.21 37.50 28.00 38.00 28.00 C 38.75 28.20 35.38 26.17 36.00 27.00 C 36.00 27.00 35.77 27.66 36.00 28.00 Z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 69.00 29.00  C 69.00 28.50 69.00 27.50 69.00 27.00 C 69.00 27.00 68.27 27.25 68.00 27.00 C 68.16 28.32 68.42 28.13 69.00 29.00 Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 131.00 29.00  C 130.84 27.93 129.84 27.47 129.00 27.00 C 129.34 27.25 130.62 28.60 131.00 29.00 Z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 135.00 33.00  C 135.19 32.15 138.00 27.68 139.00 27.00 C 136.68 28.23 135.34 30.48 135.00 33.00 Z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 205.00 30.00  C 205.93 29.31 207.12 27.52 208.00 27.00 C 206.82 27.56 205.45 28.66 205.00 30.00 Z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 223.00 30.00  C 222.34 28.68 221.35 27.70 220.00 27.00 C 220.25 27.16 222.81 29.69 223.00 30.00 Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 42.00 29.00  C 42.05 29.03 40.36 26.82 40.00 28.00 C 40.00 28.00 41.80 28.92 42.00 29.00 Z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 181.00 36.00  C 181.00 33.40 180.69 30.58 181.00 28.00 C 180.33 30.46 179.10 33.44 181.00 36.00 Z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 31.00  C 18.72 30.77 17.24 29.32 17.00 29.00 C 17.59 30.06 17.96 30.35 19.00 31.00 Z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 187.00 35.00  C 186.65 33.41 186.75 30.61 187.00 29.00 C 186.16 31.46 185.99 32.47 187.00 35.00 Z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 71.00 32.00  C 70.66 31.76 69.38 30.39 69.00 30.00 C 69.16 31.06 70.16 31.54 71.00 32.00 Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#F7FDFD",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 118.00 38.00  C 117.99 37.95 119.97 40.98 120.00 41.00 C 120.82 41.24 123.17 41.23 124.00 41.00 C 123.73 41.11 126.14 38.64 126.00 39.00 C 126.09 38.52 126.00 37.50 126.00 37.00 C 126.00 35.67 126.00 34.33 126.00 33.00 C 126.00 33.00 126.07 32.49 126.00 32.00 C 125.83 31.83 123.38 30.62 124.00 30.00 C 119.12 28.60 117.30 34.24 118.00 38.00 Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 32.00  C 125.95 31.68 124.45 29.55 124.00 30.00 C 123.38 30.62 125.83 31.83 126.00 32.00 Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 132.00 33.00  C 131.89 31.45 131.95 31.02 131.00 30.00 C 130.82 31.48 131.83 32.17 132.00 33.00 Z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#F7FDFD",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 32.00  C 140.90 32.48 141.00 33.00 141.00 33.00 C 142.97 33.25 145.02 32.81 147.00 33.00 C 147.53 31.72 146.03 31.14 146.00 30.00 C 144.33 29.49 141.44 30.01 141.00 32.00 Z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 33.00  C 141.00 33.50 141.00 34.00 141.00 34.00 C 143.33 34.00 145.67 34.00 148.00 34.00 C 148.19 32.30 147.82 30.55 146.00 30.00 C 146.03 31.14 147.53 31.72 147.00 33.00 C 145.02 32.81 142.97 33.25 141.00 33.00 Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 165.00 31.00  C 165.50 31.00 166.50 31.00 167.00 31.00 C 165.94 30.00 166.11 29.95 165.00 31.00 Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 32.00  C 210.10 31.90 212.12 29.95 212.00 30.00 C 211.19 30.22 210.14 31.08 210.00 32.00 Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#F7FDFD",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 32.00  C 210.00 32.00 210.00 32.50 210.00 33.00 C 210.00 34.67 210.00 36.33 210.00 38.00 C 210.00 38.00 209.93 38.51 210.00 39.00 C 210.10 39.10 212.12 41.05 212.00 41.00 C 212.84 41.23 215.16 41.23 216.00 41.00 C 215.98 41.01 217.93 39.07 218.00 39.00 C 218.00 39.00 217.95 38.49 218.00 38.00 C 218.21 36.08 218.38 30.87 216.00 30.00 C 215.10 29.79 212.89 29.76 212.00 30.00 C 212.12 29.95 210.10 31.90 210.00 32.00 Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 218.00 38.00  C 219.62 35.92 219.62 30.86 216.00 30.00 C 218.38 30.87 218.21 36.08 218.00 38.00 Z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 251.00 33.00  C 250.69 31.60 250.65 30.49 249.00 30.00 C 249.08 30.04 251.00 33.01 251.00 33.00 Z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 256.00 45.00  C 258.77 43.25 256.94 32.31 256.00 30.00 C 257.18 34.70 255.11 40.22 256.00 45.00 Z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 51.00 36.00  C 50.22 33.83 49.01 32.22 47.00 31.00 C 48.50 32.14 49.59 34.65 51.00 36.00 Z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 153.00 34.00  C 153.09 32.39 152.47 32.05 152.00 31.00 C 152.13 31.51 153.00 33.94 153.00 34.00 Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 162.00 34.00  C 162.12 33.64 163.57 31.52 164.00 31.00 C 162.38 31.22 162.26 32.82 162.00 34.00 Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 204.00 33.00  C 204.29 32.06 205.10 32.59 205.00 31.00 C 204.29 32.07 204.23 31.43 204.00 33.00 Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 34.00  C 141.00 34.00 141.00 33.50 141.00 33.00 C 141.00 33.00 140.90 32.48 141.00 32.00 C 139.84 31.81 139.82 34.19 141.00 34.00 Z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 37.00  C 126.64 35.41 127.65 34.69 126.00 33.00 C 126.00 34.33 126.00 35.67 126.00 37.00 Z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 38.00  C 210.00 36.33 210.00 34.67 210.00 33.00 C 208.64 34.54 208.62 36.43 210.00 38.00 Z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 28.00 35.00  C 26.77 33.86 26.61 34.48 25.00 34.00 C 26.15 34.56 26.22 35.21 28.00 35.00 Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 36.00  C 85.81 34.68 85.60 34.87 85.00 34.00 C 85.13 34.28 85.98 35.95 86.00 36.00 Z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 32.00 36.00  C 30.99 35.06 30.63 34.80 29.00 35.00 C 30.01 35.94 30.37 36.20 32.00 36.00 Z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 37.00  C 80.58 36.42 78.23 35.15 78.00 35.00 C 78.08 35.07 79.44 37.56 80.00 37.00 Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 20.00 36.00  C 20.23 36.34 20.00 37.00 20.00 37.00 C 19.62 39.30 18.39 39.37 18.00 37.00 C 17.77 36.66 18.00 36.00 18.00 36.00 C 13.43 40.45 24.54 40.42 20.00 36.00 Z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 18.00 37.00  C 18.16 37.23 19.84 37.23 20.00 37.00 C 20.00 37.00 20.23 36.34 20.00 36.00 C 19.84 35.77 18.16 35.77 18.00 36.00 C 18.00 36.00 17.77 36.66 18.00 37.00 Z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 37.00  C 34.88 36.56 34.78 35.79 33.00 36.00 C 34.22 37.13 34.33 36.63 36.00 37.00 Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 20.00 37.00  C 19.84 37.23 18.16 37.23 18.00 37.00 C 18.39 39.37 19.62 39.30 20.00 37.00 Z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 38.00 54.00  C 45.46 54.30 56.80 44.84 51.00 37.00 C 51.94 46.95 46.11 51.17 38.00 54.00 Z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 131.00 40.00  C 132.06 38.86 131.88 38.70 132.00 37.00 C 131.82 37.92 130.80 38.36 131.00 40.00 Z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 39.00  C 140.91 38.52 140.81 37.08 141.00 37.00 C 139.48 37.83 140.44 38.11 141.00 39.00 Z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 186.00 44.00  C 183.96 42.81 182.37 38.70 181.00 37.00 C 181.26 39.75 183.36 42.79 186.00 44.00 Z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 41.00 40.00  C 40.74 38.90 39.89 38.52 39.00 38.00 C 38.91 37.93 41.06 40.17 41.00 40.00 Z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 120.00 41.00  C 119.97 40.98 117.99 37.95 118.00 38.00 C 118.26 39.41 118.38 40.52 120.00 41.00 Z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 137.00 42.00  C 136.43 41.16 135.13 38.65 135.00 38.00 C 135.29 40.55 135.46 40.31 137.00 42.00 Z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 205.00 40.00  C 205.08 38.74 204.21 38.69 204.00 38.00 C 204.19 39.31 204.42 39.13 205.00 40.00 Z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 223.00 40.00  C 223.71 38.93 223.77 39.56 224.00 38.00 C 223.74 38.92 222.90 38.44 223.00 40.00 Z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 70.00 45.00  C 68.55 44.05 68.75 40.82 70.00 40.00 C 68.67 40.19 65.71 43.89 70.00 45.00 Z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 100.00 41.00  C 100.81 40.81 101.86 39.89 102.00 39.00 C 101.96 39.05 99.93 41.02 100.00 41.00 Z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 124.00 41.00  C 124.83 40.77 125.83 39.92 126.00 39.00 C 126.14 38.64 123.73 41.11 124.00 41.00 Z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 41.00  C 212.12 41.05 210.10 39.10 210.00 39.00 C 210.14 39.89 211.15 40.76 212.00 41.00 Z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 216.00 41.00  C 216.81 40.78 217.86 39.92 218.00 39.00 C 217.93 39.07 215.98 41.01 216.00 41.00 Z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 150.00 41.00  C 151.31 41.54 151.34 44.40 150.00 45.00 C 152.60 44.25 153.10 39.93 150.00 41.00 Z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 194.00 41.00  C 193.77 40.66 194.00 40.00 194.00 40.00 C 193.54 39.87 192.49 40.08 192.00 40.00 C 192.88 40.46 192.82 40.64 194.00 41.00 Z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 194.00 41.00  C 194.46 41.14 195.55 41.15 196.00 41.00 C 196.52 41.02 193.88 39.97 194.00 40.00 C 194.00 40.00 193.77 40.66 194.00 41.00 Z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 45.00  C 16.54 43.46 17.99 42.61 19.00 42.00 C 19.22 41.87 19.00 41.00 19.00 41.00 C 16.59 41.68 16.24 43.51 17.00 45.00 Z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 42.00  C 19.16 42.23 20.84 42.23 21.00 42.00 C 20.77 41.65 21.00 41.00 21.00 41.00 C 20.84 40.77 19.16 40.77 19.00 41.00 C 19.00 41.00 19.22 41.87 19.00 42.00 Z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 21.00 42.00  C 21.51 42.77 22.08 42.69 22.00 44.00 C 22.97 43.01 23.05 41.26 21.00 41.00 C 21.00 41.00 20.77 41.65 21.00 42.00 Z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 93.00 45.00  C 92.00 43.85 90.85 42.14 90.00 41.00 C 90.14 42.67 91.20 44.49 93.00 45.00 Z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 45.00  C 128.56 44.46 130.28 42.48 131.00 41.00 C 129.45 42.08 128.41 43.91 127.00 45.00 Z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 148.00 41.00  C 146.72 41.00 145.26 41.20 144.00 41.00 C 146.02 41.74 145.91 41.84 148.00 41.00 Z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 208.00 44.00  C 207.10 43.36 206.07 41.79 205.00 41.00 C 205.46 42.36 206.77 43.32 208.00 44.00 Z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 220.00 44.00  C 221.17 43.39 222.54 42.37 223.00 41.00 C 222.01 41.73 220.93 43.39 220.00 44.00 Z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 45.00  C 16.90 44.66 19.43 47.13 19.00 47.00 C 20.17 47.35 21.84 46.18 22.00 45.00 C 22.00 45.00 21.97 44.50 22.00 44.00 C 22.08 42.69 21.51 42.77 21.00 42.00 C 20.84 42.23 19.16 42.23 19.00 42.00 C 17.99 42.61 16.54 43.46 17.00 45.00 Z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 83.00 44.00  C 84.03 43.44 84.41 43.07 85.00 42.00 C 84.88 42.16 83.21 43.84 83.00 44.00 Z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 39.00 45.00  C 39.87 44.87 40.80 43.85 41.00 43.00 C 41.06 42.83 39.07 44.93 39.00 45.00 Z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 103.00 45.00  C 103.08 45.06 102.70 42.30 102.00 43.00 C 102.66 43.44 101.86 44.47 103.00 45.00 Z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#68ADF2",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 47.00  C 19.43 47.13 16.90 44.66 17.00 45.00 C 17.53 46.03 17.94 46.44 19.00 47.00 Z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 47.00  C 20.72 47.90 20.84 47.34 23.00 47.00 C 25.21 46.65 27.73 45.70 29.25 47.76 C 30.76 49.81 29.91 53.28 28.00 54.00 C 31.34 53.29 31.81 48.59 29.69 46.31 C 27.58 44.02 24.12 46.69 22.00 45.00 C 21.84 46.18 20.17 47.35 19.00 47.00 Z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 54.00  C 29.56 52.16 34.95 46.48 38.00 45.00 C 32.38 44.81 29.29 53.49 36.00 54.00 Z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 78.00 45.00  C 76.02 45.13 73.99 45.00 72.00 45.00 C 74.57 46.22 75.57 45.42 78.00 45.00 Z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 98.00 45.00  C 96.73 45.19 95.28 45.00 94.00 45.00 C 95.71 46.67 96.34 45.58 98.00 45.00 Z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 45.00  C 123.68 45.00 122.32 45.08 121.00 45.00 C 122.62 45.08 123.00 45.81 125.00 45.00 Z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 147.00 45.00  C 145.38 45.00 143.60 45.21 142.00 45.00 C 144.26 45.68 144.77 45.48 147.00 45.00 Z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 197.00 45.00  C 195.24 45.31 192.79 45.16 191.00 45.00 C 193.43 45.50 194.42 45.91 197.00 45.00 Z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 216.00 45.00  C 214.48 45.14 212.51 45.22 211.00 45.00 C 213.29 45.76 213.74 45.51 216.00 45.00 Z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0083E5",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 23.00 47.00  C 23.00 47.00 23.04 47.50 23.00 48.00 C 22.86 49.52 23.22 53.33 25.00 54.00 C 25.71 54.15 27.29 54.15 28.00 54.00 C 29.91 53.28 30.76 49.81 29.25 47.76 C 27.73 45.70 25.21 46.65 23.00 47.00 Z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5C9EF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 25.00 54.00  C 23.22 53.33 22.86 49.52 23.00 48.00 C 21.54 49.82 21.95 53.35 25.00 54.00 Z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    fill: "#F7FDFD",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 70.00  L 269.00 70.00 L 269.00 0.00 L 0.00 0.00 L 0.00 70.00 Z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 29.00  C 17.24 29.32 18.72 30.77 19.00 31.00 C 19.57 31.36 20.37 31.67 21.00 32.00 C 19.18 30.53 18.09 27.93 17.00 26.00 C 19.86 24.54 22.71 23.09 26.00 23.00 C 25.80 22.45 25.87 20.57 26.00 20.00 C 26.26 18.90 27.17 18.48 28.00 18.00 C 28.93 17.46 30.16 17.42 31.00 17.00 C 30.93 17.05 33.10 14.76 33.00 15.00 C 35.22 7.12 23.41 8.01 19.75 12.75 C 16.10 17.50 13.62 22.87 17.00 29.00 Z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 43.00 15.00  C 43.20 14.25 43.08 12.78 43.00 12.00 C 41.02 7.68 35.93 8.34 35.03 12.97 C 34.12 17.61 42.10 18.42 43.00 15.00 Z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 43.00 15.00  C 44.11 13.32 43.77 13.68 43.00 12.00 C 43.08 12.78 43.20 14.25 43.00 15.00 Z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 31.00 17.00  C 31.88 16.56 32.70 16.07 33.00 15.00 C 33.10 14.76 30.93 17.05 31.00 17.00 Z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 22.00  C 46.80 21.90 47.00 21.00 47.00 21.00 C 42.78 20.29 43.59 15.90 48.00 17.00 C 48.00 18.00 48.00 19.00 48.00 20.00 C 48.41 19.81 49.00 20.00 49.00 20.00 C 51.29 9.73 35.97 22.31 47.00 22.00 Z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 21.00  C 47.12 20.74 47.74 20.12 48.00 20.00 C 48.00 19.00 48.00 18.00 48.00 17.00 C 43.59 15.90 42.78 20.29 47.00 21.00 Z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 228.00 19.00  C 227.91 19.48 227.91 20.52 228.00 21.00 C 228.85 22.30 230.07 23.74 232.00 23.00 C 231.72 23.11 234.14 20.63 234.00 21.00 C 234.09 20.52 234.09 19.48 234.00 19.00 C 234.11 19.28 231.64 16.86 232.00 17.00 C 230.52 16.64 228.31 17.28 228.00 19.00 Z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 234.00 19.00  C 233.84 18.13 232.87 17.21 232.00 17.00 C 231.64 16.86 234.11 19.28 234.00 19.00 Z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 26.00 20.00  C 25.90 20.27 28.04 17.97 28.00 18.00 C 27.17 18.48 26.26 18.90 26.00 20.00 Z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 72.00 19.00  C 70.48 19.87 69.47 22.56 69.00 24.00 C 69.26 24.24 69.00 26.61 69.00 27.00 C 69.00 27.50 69.00 28.50 69.00 29.00 C 69.00 29.00 68.93 29.51 69.00 30.00 C 69.38 30.39 70.66 31.76 71.00 32.00 C 73.15 33.17 75.80 33.60 78.00 35.00 C 78.23 35.15 80.58 36.42 80.00 37.00 C 82.47 43.45 71.94 39.73 70.00 40.00 C 68.75 40.82 68.55 44.05 70.00 45.00 C 70.47 45.12 71.50 45.00 72.00 45.00 C 73.99 45.00 76.02 45.13 78.00 45.00 C 80.01 44.87 81.24 44.96 83.00 44.00 C 83.21 43.84 84.88 42.16 85.00 42.00 C 85.90 40.36 86.57 37.94 86.00 36.00 C 85.98 35.95 85.13 34.28 85.00 34.00 C 82.76 30.75 80.05 30.76 77.00 29.00 C 76.03 28.44 74.07 27.29 74.00 26.00 C 73.62 23.57 75.52 23.62 77.00 23.00 C 79.08 22.14 79.23 22.79 81.00 23.00 C 82.60 22.57 83.46 24.37 85.00 24.00 C 85.11 22.05 85.18 20.34 84.00 19.00 C 84.56 19.45 81.38 17.82 82.00 18.00 C 79.13 17.57 74.53 17.90 72.00 19.00 Z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 84.00 19.00  C 83.11 18.00 83.43 18.21 82.00 18.00 C 81.38 17.82 84.56 19.45 84.00 19.00 Z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 181.00 28.00  C 180.69 30.58 181.00 33.40 181.00 36.00 C 181.00 36.00 180.95 36.50 181.00 37.00 C 182.37 38.70 183.96 42.81 186.00 44.00 C 187.50 44.68 189.36 44.85 191.00 45.00 C 192.79 45.16 195.24 45.31 197.00 45.00 C 200.88 45.95 201.52 41.83 201.00 39.00 C 199.32 39.69 197.71 40.43 196.00 41.00 C 195.55 41.15 194.46 41.14 194.00 41.00 C 192.82 40.64 192.88 40.46 192.00 40.00 C 189.42 38.66 188.13 37.82 187.00 35.00 C 185.99 32.47 186.16 31.46 187.00 29.00 C 187.20 27.72 187.36 27.11 188.00 26.00 C 188.60 24.96 188.94 24.53 190.00 24.00 C 193.53 22.93 198.08 21.90 201.00 25.00 C 200.99 22.79 201.38 20.57 200.00 19.00 C 200.55 19.44 197.39 17.83 198.00 18.00 C 190.14 16.82 182.79 21.39 181.00 28.00 Z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 200.00 19.00  C 199.12 17.99 199.43 18.21 198.00 18.00 C 197.39 17.83 200.55 19.44 200.00 19.00 Z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 24.00  C 68.27 23.75 69.00 24.00 69.00 24.00 C 69.47 22.56 70.48 19.87 72.00 19.00 C 70.05 19.85 68.22 21.91 68.00 24.00 Z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 228.00 21.00  C 227.91 20.52 227.91 19.48 228.00 19.00 C 227.13 20.33 227.08 19.59 228.00 21.00 Z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 47.00 21.00  C 47.00 21.00 46.80 21.90 47.00 22.00 C 47.51 22.25 49.21 20.42 49.00 20.00 C 49.00 20.00 48.41 19.81 48.00 20.00 C 47.74 20.12 47.12 20.74 47.00 21.00 Z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 232.00 23.00  C 232.83 22.80 233.83 21.90 234.00 21.00 C 234.14 20.63 231.72 23.11 232.00 23.00 Z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 77.00 23.00  C 78.18 22.80 79.81 22.90 81.00 23.00 C 79.23 22.79 79.08 22.14 77.00 23.00 Z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 21.00 32.00  C 22.33 32.71 23.64 33.33 25.00 34.00 C 26.61 34.48 26.77 33.86 28.00 35.00 C 28.00 35.00 28.51 35.06 29.00 35.00 C 30.63 34.80 30.99 35.06 32.00 36.00 C 32.00 36.00 32.51 36.06 33.00 36.00 C 34.78 35.79 34.88 36.56 36.00 37.00 C 37.25 37.28 37.88 37.35 39.00 38.00 C 39.89 38.52 40.74 38.90 41.00 40.00 C 41.16 40.67 41.16 42.33 41.00 43.00 C 40.80 43.85 39.87 44.87 39.00 45.00 C 39.00 45.00 38.50 45.02 38.00 45.00 C 34.95 46.48 29.56 52.16 36.00 54.00 C 36.50 54.04 37.50 53.98 38.00 54.00 C 46.11 51.17 51.94 46.95 51.00 37.00 C 51.00 37.00 51.16 36.44 51.00 36.00 C 49.59 34.65 48.50 32.14 47.00 31.00 C 45.80 30.27 43.42 29.56 42.00 29.00 C 41.80 28.92 40.00 28.00 40.00 28.00 C 39.96 28.14 38.50 28.00 38.00 28.00 C 37.50 28.00 36.38 28.21 36.00 28.00 C 35.32 27.62 34.66 27.43 34.00 27.00 C 33.85 26.97 31.96 26.07 32.00 26.00 C 31.05 25.87 31.45 26.89 30.00 26.00 C 30.15 26.04 28.01 25.01 28.00 25.00 C 27.23 24.65 26.41 23.17 26.00 23.00 C 22.71 23.09 19.86 24.54 17.00 26.00 C 18.09 27.93 19.18 30.53 21.00 32.00 Z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 28.00 25.00  C 28.19 25.12 25.92 22.77 26.00 23.00 C 26.41 23.17 27.23 24.65 28.00 25.00 Z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 45.00 27.00  C 53.11 27.49 44.45 18.93 45.00 27.00 Z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 48.00 24.00  C 47.45 23.45 45.30 24.60 46.29 25.63 C 47.29 26.67 48.73 24.73 48.00 24.00 Z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 27.00  C 68.27 27.25 69.00 27.00 69.00 27.00 C 69.00 26.61 69.26 24.24 69.00 24.00 C 69.00 24.00 68.27 23.75 68.00 24.00 C 67.78 24.20 67.96 26.66 68.00 27.00 Z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 188.00 26.00  C 188.11 25.86 189.82 24.12 190.00 24.00 C 188.94 24.53 188.60 24.96 188.00 26.00 Z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 123.00 26.00  C 123.50 26.00 124.50 26.00 125.00 26.00 C 123.54 25.63 124.55 25.60 123.00 26.00 Z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 143.00 26.00  C 143.95 25.95 145.05 25.91 146.00 26.00 C 144.25 25.45 144.75 25.59 143.00 26.00 Z"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 213.00 26.00  C 213.97 25.95 215.03 25.95 216.00 26.00 C 214.37 25.62 214.68 25.62 213.00 26.00 Z"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 249.00 26.00  C 249.50 26.00 250.50 26.00 251.00 26.00 C 249.51 25.59 250.56 25.60 249.00 26.00 Z"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 32.00 26.00  C 31.87 26.22 30.47 26.13 30.00 26.00 C 31.45 26.89 31.05 25.87 32.00 26.00 Z"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 77.00 29.00  C 77.03 29.02 73.96 25.77 74.00 26.00 C 74.07 27.29 76.03 28.44 77.00 29.00 Z"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 40.00  C 90.00 35.33 90.00 30.67 90.00 26.00 C 87.60 27.24 88.71 38.26 90.00 40.00 Z"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 40.00  C 90.00 40.00 89.96 40.50 90.00 41.00 C 90.85 42.14 92.00 43.85 93.00 45.00 C 93.00 45.00 93.50 45.00 94.00 45.00 C 95.28 45.00 96.73 45.19 98.00 45.00 C 98.39 44.86 101.88 42.96 102.00 43.00 C 102.70 42.30 103.08 45.06 103.00 45.00 C 103.50 45.23 106.50 45.24 107.00 45.00 C 107.00 38.67 107.00 32.33 107.00 26.00 C 106.51 25.77 103.49 25.77 103.00 26.00 C 102.40 29.85 104.25 34.96 102.00 38.00 C 102.00 38.00 102.07 38.51 102.00 39.00 C 101.86 39.89 100.81 40.81 100.00 41.00 C 99.36 41.15 97.64 41.17 97.00 41.00 C 92.28 39.76 96.40 29.25 95.00 26.00 C 94.43 25.71 90.57 25.71 90.00 26.00 C 90.00 30.67 90.00 35.33 90.00 40.00 Z"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 97.00 41.00  C 93.09 38.88 98.84 27.98 95.00 26.00 C 96.40 29.25 92.28 39.76 97.00 41.00 Z"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 102.00 38.00  C 104.25 34.96 102.40 29.85 103.00 26.00 C 100.77 27.06 102.00 35.63 102.00 38.00 Z"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 107.00 45.00  C 108.92 44.09 108.99 26.95 107.00 26.00 C 107.00 32.33 107.00 38.67 107.00 45.00 Z"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 54.00  C 113.00 44.67 113.00 35.33 113.00 26.00 C 110.59 27.52 111.99 37.14 112.00 40.00 C 112.01 42.86 110.57 52.47 113.00 54.00 Z"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 54.00  C 114.67 54.00 116.33 54.00 118.00 54.00 C 118.00 50.67 118.00 47.33 118.00 44.00 C 119.21 43.43 120.03 44.94 121.00 45.00 C 122.32 45.08 123.68 45.00 125.00 45.00 C 125.50 45.00 126.55 45.15 127.00 45.00 C 128.41 43.91 129.45 42.08 131.00 41.00 C 131.00 41.00 131.06 40.49 131.00 40.00 C 130.80 38.36 131.82 37.92 132.00 37.00 C 132.09 35.72 132.09 34.28 132.00 33.00 C 131.83 32.17 130.82 31.48 131.00 30.00 C 131.00 30.00 131.07 29.49 131.00 29.00 C 130.62 28.60 129.34 27.25 129.00 27.00 C 127.61 26.23 126.63 26.01 125.00 26.00 C 124.50 26.00 123.50 26.00 123.00 26.00 C 122.50 26.00 121.48 25.91 121.00 26.00 C 120.37 26.24 119.94 27.64 119.00 28.00 C 118.05 28.61 116.30 23.91 113.00 26.00 C 113.00 35.33 113.00 44.67 113.00 54.00 Z"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 119.00 28.00  C 119.94 27.64 120.37 26.24 121.00 26.00 C 119.67 26.24 119.87 27.44 119.00 28.00 Z"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 139.00 27.00  C 138.00 27.68 135.19 32.15 135.00 33.00 C 134.80 34.50 134.83 36.50 135.00 38.00 C 135.13 38.65 136.43 41.16 137.00 42.00 C 138.52 43.67 139.58 44.68 142.00 45.00 C 143.60 45.21 145.38 45.00 147.00 45.00 C 147.85 45.00 149.19 45.23 150.00 45.00 C 151.34 44.40 151.31 41.54 150.00 41.00 C 149.55 41.15 148.50 41.00 148.00 41.00 C 145.91 41.84 146.02 41.74 144.00 41.00 C 142.23 40.72 141.94 40.50 141.00 39.00 C 140.44 38.11 139.48 37.83 141.00 37.00 C 145.00 37.00 149.00 37.00 153.00 37.00 C 152.94 36.01 153.08 34.99 153.00 34.00 C 153.00 33.94 152.13 31.51 152.00 31.00 C 150.76 28.22 149.45 26.34 146.00 26.00 C 145.05 25.91 143.95 25.95 143.00 26.00 C 141.31 26.09 140.46 26.23 139.00 27.00 Z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 157.00 45.00  C 157.00 38.67 157.00 32.33 157.00 26.00 C 155.00 27.17 154.98 43.72 157.00 45.00 Z"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 157.00 45.00  C 158.67 45.00 160.33 45.00 162.00 45.00 C 162.57 41.46 161.24 37.50 162.00 34.00 C 162.26 32.82 162.38 31.22 164.00 31.00 C 164.00 31.00 164.50 31.00 165.00 31.00 C 166.11 29.95 165.94 30.00 167.00 31.00 C 167.00 31.00 167.95 31.15 168.00 31.00 C 168.15 30.56 168.28 26.22 168.00 26.00 C 167.52 25.78 165.53 25.89 165.00 26.00 C 162.95 26.87 164.16 28.49 162.00 28.00 C 161.98 28.00 159.48 24.55 157.00 26.00 C 157.00 32.33 157.00 38.67 157.00 45.00 Z"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 162.00 28.00  C 164.16 28.49 162.95 26.87 165.00 26.00 C 163.81 26.25 163.19 27.93 162.00 28.00 Z"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 168.00 31.00  C 169.20 30.07 169.78 26.79 168.00 26.00 C 168.28 26.22 168.15 30.56 168.00 31.00 Z"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 208.00 27.00  C 207.12 27.52 205.93 29.31 205.00 30.00 C 205.00 30.00 204.97 30.50 205.00 31.00 C 205.10 32.59 204.29 32.06 204.00 33.00 C 203.79 34.44 203.79 36.56 204.00 38.00 C 204.21 38.69 205.08 38.74 205.00 40.00 C 205.00 40.00 204.85 40.55 205.00 41.00 C 206.07 41.79 207.10 43.36 208.00 44.00 C 209.04 44.58 209.84 44.83 211.00 45.00 C 212.51 45.22 214.48 45.14 216.00 45.00 C 217.69 44.85 218.52 44.77 220.00 44.00 C 220.93 43.39 222.01 41.73 223.00 41.00 C 223.00 41.00 223.03 40.50 223.00 40.00 C 222.90 38.44 223.74 38.92 224.00 38.00 C 224.40 35.34 224.15 32.31 223.00 30.00 C 222.81 29.69 220.25 27.16 220.00 27.00 C 218.55 26.25 217.66 26.09 216.00 26.00 C 215.03 25.95 213.97 25.95 213.00 26.00 C 211.35 26.09 209.43 26.32 208.00 27.00 Z"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 233.00 45.00  C 233.00 38.67 233.00 32.33 233.00 26.00 C 231.33 26.00 229.67 26.00 228.00 26.00 C 228.00 32.33 228.00 38.67 228.00 45.00 C 229.31 44.43 231.81 45.75 233.00 45.00 Z"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 233.00 45.00  C 234.98 43.74 235.06 27.30 233.00 26.00 C 233.00 32.33 233.00 38.67 233.00 45.00 Z"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 239.00 45.00  C 239.00 38.67 239.00 32.33 239.00 26.00 C 237.02 27.26 236.94 43.70 239.00 45.00 Z"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 239.00 45.00  C 240.67 45.00 242.33 45.00 244.00 45.00 C 244.14 41.73 242.19 27.98 249.00 30.00 C 250.65 30.49 250.69 31.60 251.00 33.00 C 251.00 37.00 251.00 41.00 251.00 45.00 C 252.31 44.43 254.81 45.75 256.00 45.00 C 255.11 40.22 257.18 34.70 256.00 30.00 C 254.91 27.32 254.35 26.00 251.00 26.00 C 250.50 26.00 249.50 26.00 249.00 26.00 C 248.50 26.00 247.48 25.91 247.00 26.00 C 246.37 26.24 245.94 27.64 245.00 28.00 C 244.05 28.61 242.30 23.91 239.00 26.00 C 239.00 32.33 239.00 38.67 239.00 45.00 Z"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 28.00  C 245.94 27.64 246.37 26.24 247.00 26.00 C 245.67 26.24 245.87 27.44 245.00 28.00 Z"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 28.00  C 35.77 27.66 36.00 27.00 36.00 27.00 C 35.82 26.76 34.48 27.09 34.00 27.00 C 34.66 27.43 35.32 27.62 36.00 28.00 Z"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 28.00  C 36.38 28.21 37.50 28.00 38.00 28.00 C 38.75 28.20 35.38 26.17 36.00 27.00 C 36.00 27.00 35.77 27.66 36.00 28.00 Z"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 69.00 29.00  C 69.00 28.50 69.00 27.50 69.00 27.00 C 69.00 27.00 68.27 27.25 68.00 27.00 C 68.16 28.32 68.42 28.13 69.00 29.00 Z"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 131.00 29.00  C 130.84 27.93 129.84 27.47 129.00 27.00 C 129.34 27.25 130.62 28.60 131.00 29.00 Z"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 135.00 33.00  C 135.19 32.15 138.00 27.68 139.00 27.00 C 136.68 28.23 135.34 30.48 135.00 33.00 Z"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 205.00 30.00  C 205.93 29.31 207.12 27.52 208.00 27.00 C 206.82 27.56 205.45 28.66 205.00 30.00 Z"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 223.00 30.00  C 222.34 28.68 221.35 27.70 220.00 27.00 C 220.25 27.16 222.81 29.69 223.00 30.00 Z"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 42.00 29.00  C 42.05 29.03 40.36 26.82 40.00 28.00 C 40.00 28.00 41.80 28.92 42.00 29.00 Z"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 181.00 36.00  C 181.00 33.40 180.69 30.58 181.00 28.00 C 180.33 30.46 179.10 33.44 181.00 36.00 Z"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 31.00  C 18.72 30.77 17.24 29.32 17.00 29.00 C 17.59 30.06 17.96 30.35 19.00 31.00 Z"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 187.00 35.00  C 186.65 33.41 186.75 30.61 187.00 29.00 C 186.16 31.46 185.99 32.47 187.00 35.00 Z"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 71.00 32.00  C 70.66 31.76 69.38 30.39 69.00 30.00 C 69.16 31.06 70.16 31.54 71.00 32.00 Z"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    fill: "#F7FDFD",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 118.00 38.00  C 117.99 37.95 119.97 40.98 120.00 41.00 C 120.82 41.24 123.17 41.23 124.00 41.00 C 123.73 41.11 126.14 38.64 126.00 39.00 C 126.09 38.52 126.00 37.50 126.00 37.00 C 126.00 35.67 126.00 34.33 126.00 33.00 C 126.00 33.00 126.07 32.49 126.00 32.00 C 125.83 31.83 123.38 30.62 124.00 30.00 C 119.12 28.60 117.30 34.24 118.00 38.00 Z"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 32.00  C 125.95 31.68 124.45 29.55 124.00 30.00 C 123.38 30.62 125.83 31.83 126.00 32.00 Z"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 132.00 33.00  C 131.89 31.45 131.95 31.02 131.00 30.00 C 130.82 31.48 131.83 32.17 132.00 33.00 Z"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    fill: "#F7FDFD",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 32.00  C 140.90 32.48 141.00 33.00 141.00 33.00 C 142.97 33.25 145.02 32.81 147.00 33.00 C 147.53 31.72 146.03 31.14 146.00 30.00 C 144.33 29.49 141.44 30.01 141.00 32.00 Z"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 33.00  C 141.00 33.50 141.00 34.00 141.00 34.00 C 143.33 34.00 145.67 34.00 148.00 34.00 C 148.19 32.30 147.82 30.55 146.00 30.00 C 146.03 31.14 147.53 31.72 147.00 33.00 C 145.02 32.81 142.97 33.25 141.00 33.00 Z"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 165.00 31.00  C 165.50 31.00 166.50 31.00 167.00 31.00 C 165.94 30.00 166.11 29.95 165.00 31.00 Z"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 32.00  C 210.10 31.90 212.12 29.95 212.00 30.00 C 211.19 30.22 210.14 31.08 210.00 32.00 Z"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    fill: "#F7FDFD",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 32.00  C 210.00 32.00 210.00 32.50 210.00 33.00 C 210.00 34.67 210.00 36.33 210.00 38.00 C 210.00 38.00 209.93 38.51 210.00 39.00 C 210.10 39.10 212.12 41.05 212.00 41.00 C 212.84 41.23 215.16 41.23 216.00 41.00 C 215.98 41.01 217.93 39.07 218.00 39.00 C 218.00 39.00 217.95 38.49 218.00 38.00 C 218.21 36.08 218.38 30.87 216.00 30.00 C 215.10 29.79 212.89 29.76 212.00 30.00 C 212.12 29.95 210.10 31.90 210.00 32.00 Z"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 218.00 38.00  C 219.62 35.92 219.62 30.86 216.00 30.00 C 218.38 30.87 218.21 36.08 218.00 38.00 Z"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 251.00 33.00  C 250.69 31.60 250.65 30.49 249.00 30.00 C 249.08 30.04 251.00 33.01 251.00 33.00 Z"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 256.00 45.00  C 258.77 43.25 256.94 32.31 256.00 30.00 C 257.18 34.70 255.11 40.22 256.00 45.00 Z"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 51.00 36.00  C 50.22 33.83 49.01 32.22 47.00 31.00 C 48.50 32.14 49.59 34.65 51.00 36.00 Z"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 153.00 34.00  C 153.09 32.39 152.47 32.05 152.00 31.00 C 152.13 31.51 153.00 33.94 153.00 34.00 Z"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 162.00 34.00  C 162.12 33.64 163.57 31.52 164.00 31.00 C 162.38 31.22 162.26 32.82 162.00 34.00 Z"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 204.00 33.00  C 204.29 32.06 205.10 32.59 205.00 31.00 C 204.29 32.07 204.23 31.43 204.00 33.00 Z"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 34.00  C 141.00 34.00 141.00 33.50 141.00 33.00 C 141.00 33.00 140.90 32.48 141.00 32.00 C 139.84 31.81 139.82 34.19 141.00 34.00 Z"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 37.00  C 126.64 35.41 127.65 34.69 126.00 33.00 C 126.00 34.33 126.00 35.67 126.00 37.00 Z"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 210.00 38.00  C 210.00 36.33 210.00 34.67 210.00 33.00 C 208.64 34.54 208.62 36.43 210.00 38.00 Z"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 28.00 35.00  C 26.77 33.86 26.61 34.48 25.00 34.00 C 26.15 34.56 26.22 35.21 28.00 35.00 Z"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 36.00  C 85.81 34.68 85.60 34.87 85.00 34.00 C 85.13 34.28 85.98 35.95 86.00 36.00 Z"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 32.00 36.00  C 30.99 35.06 30.63 34.80 29.00 35.00 C 30.01 35.94 30.37 36.20 32.00 36.00 Z"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 37.00  C 80.58 36.42 78.23 35.15 78.00 35.00 C 78.08 35.07 79.44 37.56 80.00 37.00 Z"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 20.00 36.00  C 20.23 36.34 20.00 37.00 20.00 37.00 C 19.62 39.30 18.39 39.37 18.00 37.00 C 17.77 36.66 18.00 36.00 18.00 36.00 C 13.43 40.45 24.54 40.42 20.00 36.00 Z"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 18.00 37.00  C 18.16 37.23 19.84 37.23 20.00 37.00 C 20.00 37.00 20.23 36.34 20.00 36.00 C 19.84 35.77 18.16 35.77 18.00 36.00 C 18.00 36.00 17.77 36.66 18.00 37.00 Z"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 37.00  C 34.88 36.56 34.78 35.79 33.00 36.00 C 34.22 37.13 34.33 36.63 36.00 37.00 Z"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 20.00 37.00  C 19.84 37.23 18.16 37.23 18.00 37.00 C 18.39 39.37 19.62 39.30 20.00 37.00 Z"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 38.00 54.00  C 45.46 54.30 56.80 44.84 51.00 37.00 C 51.94 46.95 46.11 51.17 38.00 54.00 Z"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 131.00 40.00  C 132.06 38.86 131.88 38.70 132.00 37.00 C 131.82 37.92 130.80 38.36 131.00 40.00 Z"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 141.00 39.00  C 140.91 38.52 140.81 37.08 141.00 37.00 C 139.48 37.83 140.44 38.11 141.00 39.00 Z"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 186.00 44.00  C 183.96 42.81 182.37 38.70 181.00 37.00 C 181.26 39.75 183.36 42.79 186.00 44.00 Z"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 41.00 40.00  C 40.74 38.90 39.89 38.52 39.00 38.00 C 38.91 37.93 41.06 40.17 41.00 40.00 Z"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 120.00 41.00  C 119.97 40.98 117.99 37.95 118.00 38.00 C 118.26 39.41 118.38 40.52 120.00 41.00 Z"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 137.00 42.00  C 136.43 41.16 135.13 38.65 135.00 38.00 C 135.29 40.55 135.46 40.31 137.00 42.00 Z"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 205.00 40.00  C 205.08 38.74 204.21 38.69 204.00 38.00 C 204.19 39.31 204.42 39.13 205.00 40.00 Z"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 223.00 40.00  C 223.71 38.93 223.77 39.56 224.00 38.00 C 223.74 38.92 222.90 38.44 223.00 40.00 Z"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 70.00 45.00  C 68.55 44.05 68.75 40.82 70.00 40.00 C 68.67 40.19 65.71 43.89 70.00 45.00 Z"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 100.00 41.00  C 100.81 40.81 101.86 39.89 102.00 39.00 C 101.96 39.05 99.93 41.02 100.00 41.00 Z"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 124.00 41.00  C 124.83 40.77 125.83 39.92 126.00 39.00 C 126.14 38.64 123.73 41.11 124.00 41.00 Z"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 41.00  C 212.12 41.05 210.10 39.10 210.00 39.00 C 210.14 39.89 211.15 40.76 212.00 41.00 Z"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 216.00 41.00  C 216.81 40.78 217.86 39.92 218.00 39.00 C 217.93 39.07 215.98 41.01 216.00 41.00 Z"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 150.00 41.00  C 151.31 41.54 151.34 44.40 150.00 45.00 C 152.60 44.25 153.10 39.93 150.00 41.00 Z"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 194.00 41.00  C 193.77 40.66 194.00 40.00 194.00 40.00 C 193.54 39.87 192.49 40.08 192.00 40.00 C 192.88 40.46 192.82 40.64 194.00 41.00 Z"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 194.00 41.00  C 194.46 41.14 195.55 41.15 196.00 41.00 C 196.52 41.02 193.88 39.97 194.00 40.00 C 194.00 40.00 193.77 40.66 194.00 41.00 Z"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 45.00  C 16.54 43.46 17.99 42.61 19.00 42.00 C 19.22 41.87 19.00 41.00 19.00 41.00 C 16.59 41.68 16.24 43.51 17.00 45.00 Z"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 42.00  C 19.16 42.23 20.84 42.23 21.00 42.00 C 20.77 41.65 21.00 41.00 21.00 41.00 C 20.84 40.77 19.16 40.77 19.00 41.00 C 19.00 41.00 19.22 41.87 19.00 42.00 Z"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 21.00 42.00  C 21.51 42.77 22.08 42.69 22.00 44.00 C 22.97 43.01 23.05 41.26 21.00 41.00 C 21.00 41.00 20.77 41.65 21.00 42.00 Z"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 93.00 45.00  C 92.00 43.85 90.85 42.14 90.00 41.00 C 90.14 42.67 91.20 44.49 93.00 45.00 Z"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 45.00  C 128.56 44.46 130.28 42.48 131.00 41.00 C 129.45 42.08 128.41 43.91 127.00 45.00 Z"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 148.00 41.00  C 146.72 41.00 145.26 41.20 144.00 41.00 C 146.02 41.74 145.91 41.84 148.00 41.00 Z"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 208.00 44.00  C 207.10 43.36 206.07 41.79 205.00 41.00 C 205.46 42.36 206.77 43.32 208.00 44.00 Z"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 220.00 44.00  C 221.17 43.39 222.54 42.37 223.00 41.00 C 222.01 41.73 220.93 43.39 220.00 44.00 Z"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 17.00 45.00  C 16.90 44.66 19.43 47.13 19.00 47.00 C 20.17 47.35 21.84 46.18 22.00 45.00 C 22.00 45.00 21.97 44.50 22.00 44.00 C 22.08 42.69 21.51 42.77 21.00 42.00 C 20.84 42.23 19.16 42.23 19.00 42.00 C 17.99 42.61 16.54 43.46 17.00 45.00 Z"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 83.00 44.00  C 84.03 43.44 84.41 43.07 85.00 42.00 C 84.88 42.16 83.21 43.84 83.00 44.00 Z"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 39.00 45.00  C 39.87 44.87 40.80 43.85 41.00 43.00 C 41.06 42.83 39.07 44.93 39.00 45.00 Z"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 103.00 45.00  C 103.08 45.06 102.70 42.30 102.00 43.00 C 102.66 43.44 101.86 44.47 103.00 45.00 Z"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    fill: "#68ADF2",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 47.00  C 19.43 47.13 16.90 44.66 17.00 45.00 C 17.53 46.03 17.94 46.44 19.00 47.00 Z"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 19.00 47.00  C 20.72 47.90 20.84 47.34 23.00 47.00 C 25.21 46.65 27.73 45.70 29.25 47.76 C 30.76 49.81 29.91 53.28 28.00 54.00 C 31.34 53.29 31.81 48.59 29.69 46.31 C 27.58 44.02 24.12 46.69 22.00 45.00 C 21.84 46.18 20.17 47.35 19.00 47.00 Z"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 36.00 54.00  C 29.56 52.16 34.95 46.48 38.00 45.00 C 32.38 44.81 29.29 53.49 36.00 54.00 Z"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 78.00 45.00  C 76.02 45.13 73.99 45.00 72.00 45.00 C 74.57 46.22 75.57 45.42 78.00 45.00 Z"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 98.00 45.00  C 96.73 45.19 95.28 45.00 94.00 45.00 C 95.71 46.67 96.34 45.58 98.00 45.00 Z"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 45.00  C 123.68 45.00 122.32 45.08 121.00 45.00 C 122.62 45.08 123.00 45.81 125.00 45.00 Z"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 147.00 45.00  C 145.38 45.00 143.60 45.21 142.00 45.00 C 144.26 45.68 144.77 45.48 147.00 45.00 Z"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 197.00 45.00  C 195.24 45.31 192.79 45.16 191.00 45.00 C 193.43 45.50 194.42 45.91 197.00 45.00 Z"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 216.00 45.00  C 214.48 45.14 212.51 45.22 211.00 45.00 C 213.29 45.76 213.74 45.51 216.00 45.00 Z"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    fill: "#0083E5",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 23.00 47.00  C 23.00 47.00 23.04 47.50 23.00 48.00 C 22.86 49.52 23.22 53.33 25.00 54.00 C 25.71 54.15 27.29 54.15 28.00 54.00 C 29.91 53.28 30.76 49.81 29.25 47.76 C 27.73 45.70 25.21 46.65 23.00 47.00 Z"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5C9EF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 25.00 54.00  C 23.22 53.33 22.86 49.52 23.00 48.00 C 21.54 49.82 21.95 53.35 25.00 54.00 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d4ff66aecf72075f0c99fae8ca8cfe2.svg";
export { ForwardRef as ReactComponent };